import Vue from 'vue'
import { decode, parsePath, withoutBase, withoutTrailingSlash, normalizeURL } from 'ufo'

import { getMatchedComponentsInstances, getChildrenComponentInstancesUsingFetch, promisify, globalHandleError, urlJoin, sanitizeComponent } from './utils'
import NuxtError from '../layouts/error.vue'
import NuxtLoading from '~/components/loading.vue'

import '../node_modules/@fortawesome/fontawesome-svg-core/styles.css'

import '../assets/css/bootstrap.min.css'

import '../assets/css/style.css'

import '../assets/css/admin.css'

import '../assets/css/animate.css'

import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css'

import '../assets/css/branding.css'

import '../node_modules/swiper/dist/css/swiper.css'

import '../node_modules/vue-tour/dist/vue-tour.css'

import _ea17b4de from '../layouts/main_Customizer/dinputs/animacionPicker.vue'
import _efc1ff82 from '../layouts/main_Customizer/dinputs/colorPicker.vue'
import _ef175a4a from '../layouts/main_Customizer/dinputs/dateTimePicker.vue'
import _ce9a829e from '../layouts/main_Customizer/dinputs/efectPicker.vue'
import _1dc2118f from '../layouts/main_Customizer/dinputs/fontPicker.vue'
import _31e4fa39 from '../layouts/main_Customizer/dinputs/iconPicker.vue'
import _27e47132 from '../layouts/main_Customizer/dinputs/opacityPicker.vue'
import _5e1a507e from '../layouts/main_Customizer/dinputs/sizePicker.vue'
import _5b869034 from '../layouts/main_Customizer/dinputs/switchPicker.vue'
import _3872f606 from '../layouts/main_Customizer/dinputs/videoEmbededPicker.vue'
import _7fae79f9 from '../layouts/main_Customizer/dragndrop/editAvatar.vue'
import _949e88e8 from '../layouts/main_Customizer/dragndrop/editBeneficio.vue'
import _2d73e946 from '../layouts/main_Customizer/dragndrop/editBoton.vue'
import _2d9d38ad from '../layouts/main_Customizer/dragndrop/editEmpty.vue'
import _2281ec2b from '../layouts/main_Customizer/dragndrop/editHTML.vue'
import _e65389da from '../layouts/main_Customizer/dragndrop/editImagen.vue'
import _22841094 from '../layouts/main_Customizer/dragndrop/editLine.vue'
import _6cb71eb9 from '../layouts/main_Customizer/dragndrop/editParrafo.vue'
import _cddef520 from '../layouts/main_Customizer/dragndrop/editPremio.vue'
import _c3f85fe6 from '../layouts/main_Customizer/dragndrop/editSocial.vue'
import _2e63a466 from '../layouts/main_Customizer/dragndrop/editSpace.vue'
import _c127f74e from '../layouts/main_Customizer/dragndrop/editTitulo.vue'
import _72ef7fff from '../layouts/main_Customizer/dragndrop/editUbicacion.vue'
import _2e8ac7db from '../layouts/main_Customizer/dragndrop/editVideo.vue'
import _6f1c0347 from '../layouts/main_Customizer/editorBottomMenu.vue'
import _1c4e0857 from '../layouts/main_Customizer/editorTopMenu.vue'
import _5ad6e034 from '../layouts/main_Customizer/leftCol_Desktop.vue'
import _253d20d0 from '../layouts/main_Customizer/leftCol_Mobile.vue'
import _5b18d779 from '../layouts/main_Customizer/leftCol_MP.vue'
import _3e52bdcd from '../layouts/main_Customizer/leftColCompartirA.vue'
import _3e52bdd0 from '../layouts/main_Customizer/leftColCompartirD.vue'
import _2ea4c2b4 from '../layouts/main_Customizer/leftColGuardarA.vue'
import _2ea4c2b7 from '../layouts/main_Customizer/leftColGuardarD.vue'
import _07f7f1fc from '../layouts/main_Customizer/leftColHalf.vue'
import _11cb8eac from '../layouts/main_Customizer/leftColInfoA.vue'
import _11cb8ea6 from '../layouts/main_Customizer/leftColInfoD.vue'
import _5e0985b8 from '../layouts/main_Customizer/leftColMembreA.vue'
import _5e0985bb from '../layouts/main_Customizer/leftColMembreD.vue'
import _414c3d28 from '../layouts/main_Customizer/leftColSettings.vue'
import _1c4e4fe0 from '../layouts/main_Customizer/leftColSobreA_Mobile.vue'
import _056cae9e from '../layouts/main_Customizer/leftColSobreA.vue'
import _056cae98 from '../layouts/main_Customizer/leftColSobreD.vue'
import _114142d8 from '../layouts/main_Customizer/limitedEdition.vue'
import _3fa68b8f from '../layouts/main_Customizer/rightColPlantilla.vue'
import _4e7f5aa1 from '../layouts/main_Directorio/main_Busqueda/AlgoliaSearch.vue'
import _10dc3708 from '../layouts/main_Directorio/main_Busqueda/mainDir.vue'
import _48597f40 from '../layouts/main_Directorio/main_Busqueda/Search.vue'
import _55c15fa6 from '../layouts/main_Directorio/main_Busqueda/searchDir.vue'
import _134f94c5 from '../layouts/main_Directorio/main_Busqueda/subDir.vue'
import _1d630d55 from '../layouts/main_Directorio/main_Contactos/contactDir_c.vue'
import _1d630d62 from '../layouts/main_Directorio/main_Contactos/contactDir_p.vue'
import _32399da6 from '../layouts/main_Directorio/main_Contactos/main_Contactos_c.vue'
import _32399db3 from '../layouts/main_Directorio/main_Contactos/main_Contactos_p.vue'
import _5bebfaf0 from '../layouts/main_Directorio/main_Partners/partnerDir.vue'
import _f6013aea from '../layouts/main_Directorio/main_Partners/PartnerInfo.vue'
import _4fcc99e4 from '../layouts/main_Directorio/main/dirPreview.vue'
import _5d8d7bcd from '../layouts/main_Directorio/main/miniDirectory.vue'
import _4fee08cc from '../layouts/main_Directorio/main/miniLinckard.vue'
import _4f036929 from '../layouts/main_Directorio/main/miniMulticard.vue'
import _a7bbdbb0 from '../layouts/main_Directorio/main/miniPartner.vue'
import _1cd5cc19 from '../layouts/main_Preview/camaraQR.vue'
import _2b71e48e from '../layouts/main_Preview/main_Preview.vue'
import _1a3d81ea from '../layouts/main_Preview/previewADDTOHOME.vue'
import _6c753b1f from '../layouts/main_Preview/previewInfo.vue'
import _2a6a8a51 from '../layouts/main_Preview/previewMembre.vue'
import _6c76ebd0 from '../layouts/main_Preview/previewMenu.vue'
import _22bf79e8 from '../layouts/main_Preview/previewSobre.vue'
import _6140e73c from '../layouts/main_Preview/previewSobreDrag.vue'
import _77d887ce from '../layouts/panel.vue'
import _3f9d0104 from '../layouts/signature_Customizer/iconssocial.vue'
import _d751abe2 from '../layouts/signature_Customizer/integrations/email.vue'
import _0b552244 from '../layouts/signature_Customizer/integrations/gsuite.vue'
import _2e9bba8e from '../layouts/signature_Customizer/leftCol_SC.vue'
import _2e9bba8c from '../layouts/signature_Customizer/leftCol_SD.vue'
import _2e9bba6c from '../layouts/signature_Customizer/leftCol_ST.vue'
import _7b1c86c2 from '../layouts/signature_Customizer/signatureTopMenu.vue'
import _b8881f14 from '../layouts/signature_Customizer/templates.vue'
import _6f6c098b from './layouts/default.vue'

const layouts = { "_main_Customizer/dinputs/animacionPicker": sanitizeComponent(_ea17b4de),"_main_Customizer/dinputs/colorPicker": sanitizeComponent(_efc1ff82),"_main_Customizer/dinputs/dateTimePicker": sanitizeComponent(_ef175a4a),"_main_Customizer/dinputs/efectPicker": sanitizeComponent(_ce9a829e),"_main_Customizer/dinputs/fontPicker": sanitizeComponent(_1dc2118f),"_main_Customizer/dinputs/iconPicker": sanitizeComponent(_31e4fa39),"_main_Customizer/dinputs/opacityPicker": sanitizeComponent(_27e47132),"_main_Customizer/dinputs/sizePicker": sanitizeComponent(_5e1a507e),"_main_Customizer/dinputs/switchPicker": sanitizeComponent(_5b869034),"_main_Customizer/dinputs/videoEmbededPicker": sanitizeComponent(_3872f606),"_main_Customizer/dragndrop/editAvatar": sanitizeComponent(_7fae79f9),"_main_Customizer/dragndrop/editBeneficio": sanitizeComponent(_949e88e8),"_main_Customizer/dragndrop/editBoton": sanitizeComponent(_2d73e946),"_main_Customizer/dragndrop/editEmpty": sanitizeComponent(_2d9d38ad),"_main_Customizer/dragndrop/editHTML": sanitizeComponent(_2281ec2b),"_main_Customizer/dragndrop/editImagen": sanitizeComponent(_e65389da),"_main_Customizer/dragndrop/editLine": sanitizeComponent(_22841094),"_main_Customizer/dragndrop/editParrafo": sanitizeComponent(_6cb71eb9),"_main_Customizer/dragndrop/editPremio": sanitizeComponent(_cddef520),"_main_Customizer/dragndrop/editSocial": sanitizeComponent(_c3f85fe6),"_main_Customizer/dragndrop/editSpace": sanitizeComponent(_2e63a466),"_main_Customizer/dragndrop/editTitulo": sanitizeComponent(_c127f74e),"_main_Customizer/dragndrop/editUbicacion": sanitizeComponent(_72ef7fff),"_main_Customizer/dragndrop/editVideo": sanitizeComponent(_2e8ac7db),"_main_Customizer/editorBottomMenu": sanitizeComponent(_6f1c0347),"_main_Customizer/editorTopMenu": sanitizeComponent(_1c4e0857),"_main_Customizer/leftCol_Desktop": sanitizeComponent(_5ad6e034),"_main_Customizer/leftCol_Mobile": sanitizeComponent(_253d20d0),"_main_Customizer/leftCol_MP": sanitizeComponent(_5b18d779),"_main_Customizer/leftColCompartirA": sanitizeComponent(_3e52bdcd),"_main_Customizer/leftColCompartirD": sanitizeComponent(_3e52bdd0),"_main_Customizer/leftColGuardarA": sanitizeComponent(_2ea4c2b4),"_main_Customizer/leftColGuardarD": sanitizeComponent(_2ea4c2b7),"_main_Customizer/leftColHalf": sanitizeComponent(_07f7f1fc),"_main_Customizer/leftColInfoA": sanitizeComponent(_11cb8eac),"_main_Customizer/leftColInfoD": sanitizeComponent(_11cb8ea6),"_main_Customizer/leftColMembreA": sanitizeComponent(_5e0985b8),"_main_Customizer/leftColMembreD": sanitizeComponent(_5e0985bb),"_main_Customizer/leftColSettings": sanitizeComponent(_414c3d28),"_main_Customizer/leftColSobreA_Mobile": sanitizeComponent(_1c4e4fe0),"_main_Customizer/leftColSobreA": sanitizeComponent(_056cae9e),"_main_Customizer/leftColSobreD": sanitizeComponent(_056cae98),"_main_Customizer/limitedEdition": sanitizeComponent(_114142d8),"_main_Customizer/rightColPlantilla": sanitizeComponent(_3fa68b8f),"_main_Directorio/main_Busqueda/AlgoliaSearch": sanitizeComponent(_4e7f5aa1),"_main_Directorio/main_Busqueda/mainDir": sanitizeComponent(_10dc3708),"_main_Directorio/main_Busqueda/Search": sanitizeComponent(_48597f40),"_main_Directorio/main_Busqueda/searchDir": sanitizeComponent(_55c15fa6),"_main_Directorio/main_Busqueda/subDir": sanitizeComponent(_134f94c5),"_main_Directorio/main_Contactos/contactDir_c": sanitizeComponent(_1d630d55),"_main_Directorio/main_Contactos/contactDir_p": sanitizeComponent(_1d630d62),"_main_Directorio/main_Contactos/main_Contactos_c": sanitizeComponent(_32399da6),"_main_Directorio/main_Contactos/main_Contactos_p": sanitizeComponent(_32399db3),"_main_Directorio/main_Partners/partnerDir": sanitizeComponent(_5bebfaf0),"_main_Directorio/main_Partners/PartnerInfo": sanitizeComponent(_f6013aea),"_main_Directorio/main/dirPreview": sanitizeComponent(_4fcc99e4),"_main_Directorio/main/miniDirectory": sanitizeComponent(_5d8d7bcd),"_main_Directorio/main/miniLinckard": sanitizeComponent(_4fee08cc),"_main_Directorio/main/miniMulticard": sanitizeComponent(_4f036929),"_main_Directorio/main/miniPartner": sanitizeComponent(_a7bbdbb0),"_main_Preview/camaraQR": sanitizeComponent(_1cd5cc19),"_main_Preview/main_Preview": sanitizeComponent(_2b71e48e),"_main_Preview/previewADDTOHOME": sanitizeComponent(_1a3d81ea),"_main_Preview/previewInfo": sanitizeComponent(_6c753b1f),"_main_Preview/previewMembre": sanitizeComponent(_2a6a8a51),"_main_Preview/previewMenu": sanitizeComponent(_6c76ebd0),"_main_Preview/previewSobre": sanitizeComponent(_22bf79e8),"_main_Preview/previewSobreDrag": sanitizeComponent(_6140e73c),"_panel": sanitizeComponent(_77d887ce),"_signature_Customizer/iconssocial": sanitizeComponent(_3f9d0104),"_signature_Customizer/integrations/email": sanitizeComponent(_d751abe2),"_signature_Customizer/integrations/gsuite": sanitizeComponent(_0b552244),"_signature_Customizer/leftCol_SC": sanitizeComponent(_2e9bba8e),"_signature_Customizer/leftCol_SD": sanitizeComponent(_2e9bba8c),"_signature_Customizer/leftCol_ST": sanitizeComponent(_2e9bba6c),"_signature_Customizer/signatureTopMenu": sanitizeComponent(_7b1c86c2),"_signature_Customizer/templates": sanitizeComponent(_b8881f14),"_default": sanitizeComponent(_6f6c098b) }

export default {
  render (h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })

    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter (el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [templateEl])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,

      transitionEl
    ])
  },

  data: () => ({
    isOnline: true,

    layout: null,
    layoutName: '',

    nbFetching: 0
    }),

  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    this.$root.$options.$nuxt = this

    if (process.client) {
      // add to window so we can listen when ready
      window.$nuxt = this

      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  async mounted () {
    this.$loading = this.$refs.loading
  },

  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline () {
      return !this.isOnline
    },

    isFetching () {
      return this.nbFetching > 0
    },

    isPreview () {
      return Boolean(this.$options.previewData)
    },
  },

  methods: {
    refreshOnlineStatus () {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    async refresh () {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }
      this.$loading.start()

      const promises = pages.map(async (page) => {
        let p = []

        // Old fetch
        if (page.$options.fetch && page.$options.fetch.length) {
          p.push(promisify(page.$options.fetch, this.context))
        }

        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }

        // Wait for asyncData & old fetch to finish
        await Promise.all(p)
        // Cleanup refs
        p = []

        if (page.$fetch) {
          p.push(page.$fetch())
        }
        // Get all component instance to call $fetch
        for (const component of getChildrenComponentInstancesUsingFetch(page.$vnode.componentInstance)) {
          p.push(component.$fetch())
        }

        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        this.$loading.fail(error)
        globalHandleError(error)
        this.error(error)
      }
      this.$loading.finish()
    },
    errorChanged () {
      if (this.nuxt.err) {
        if (this.$loading) {
          if (this.$loading.fail) {
            this.$loading.fail(this.nuxt.err)
          }
          if (this.$loading.finish) {
            this.$loading.finish()
          }
        }

        let errorLayout = (NuxtError.options || NuxtError).layout;

        if (typeof errorLayout === 'function') {
          errorLayout = errorLayout(this.context)
        }

        this.nuxt.errPageReady = true
        this.setLayout(errorLayout)
      }
    },

    setLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    },
  },

  components: {
    NuxtLoading
  }
}
